/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: index.ts
 * Project: mle-client-n
 * Committed last: 2022/1/29 @ 1058
 * ---
 * Description:
 */

import {
  barcodeColors,
  circleControlGroup,
  dimensionsControlGroup,
  fillControlGroup,
  fontControls,
  fontStyleControls,
  generalTextControls,
  layerControlGroup,
  lineControls,
  marginControlGroup,
  positionControlGroup,
  richTextGenerals,
  rotationControlGroup,
  strokeControlGroup
}                            from './general.controls';
import { alignmentControls } from './alignment.controls';

/**
 * Rappresenta il tipo di gruppo di controllo generale
 */
export enum GeneralControlGroupTypes {
  POSITION = 'Posizione',
  DIMENSIONS = 'Dimensioni',
  ROTATION = 'Rotazione',
  RADIUS = 'Raggio',
  COLOR = 'Colore',
  COLORS = 'Sfondo',
  STROKE = 'Bordo',
  LAYERS = 'Livelli',
  TEXT = 'Testo',
  FONT = 'Font',
  RICH_TEXT = 'Testo multistile',
  STYLE = 'Stile testo',
  ALIGNMENT = 'Allineamento',
  ROW = 'Righe',
}

/**
 * All general controls
 */
export const GeneralControls = {
  fillControlGroup,
  circleControlGroup,
  layerControlGroup,
  dimensionsControlGroup,
  rotationControlGroup,
  strokeControlGroup,
  marginControlGroup,
  positionControlGroup,
  generalTextControls,
  fontControls,
  richTextGenerals,
  fontStyleControls,
  alignmentControls,
  lineControls,
  backgroundColorControls: barcodeColors,
};
